import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { Content } from './content';

export const LightBox = ({ visible, staticUrl, baseUrl, onClose, storeUrl }) => (
    <Lightbox
        opened={visible}
        onClose={onClose}
        additionalClassNames={['friendbuy-light-box__lightbox']}
    >
        <Content
            onClose={onClose}
            staticUrl={staticUrl}
            baseUrl={baseUrl}
            storeUrl={storeUrl}
        />
    </Lightbox>
);

LightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    staticUrl: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    storeUrl: PropTypes.string.isRequired,
};

LightBox.defaultProps = {
    storeUrl: '',
};
